import React, { forwardRef } from 'react';
import { usePriceStore } from '../../../store/price-store';
import { number } from 'mathjs';
import { Button, Skeleton } from '@/shared/components';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { usePriceFormat } from '@/hooks/use-price-format';
import { useCountry } from '@/hooks/use-country';
import { useEventTracking } from '@/shared/tracking/use-tracking';
import { getContactUsLink } from '@/app/utils/get-contact-us-link';
import { useRouter } from 'next/navigation';
interface IProps {
  product: any;
}

const ListPrice = forwardRef<HTMLInputElement, IProps>(function ListPrice(props, ref) {
  const router = useRouter();
  const { isCN } = useCountry();
  const { product } = props;
  const { productPrice } = usePriceStore();
  const { t, lang } = useLang(NAMESPACE.favorites);
  const { t: commonT } = useLang(NAMESPACE.common);
  const getFormattedPrice = usePriceFormat();
  const price = productPrice?.[product.catalogNumber];
  const inValidItem =
    product?.warningMessageStatus === 'DISCONTINUED' ||
    product?.warningMessageStatus === 'BLOCKED' ||
    (product?.dwgDepletedStockFlag && isCN);
  const showPrice = price?.priceStatus === 'Orderable' && !inValidItem;
  const { trackEvent } = useEventTracking();
  return (
    <>
      {price && (
        <div
          className={`flex flex-col sm:row-start-4 sm:col-start-2 sm:col-span-2 sm:mt-2 ${
            !showPrice ? 'items-end sm:items-start' : ''
          }`}
        >
          {showPrice && (
            <>
              {price && (
                <>
                  <span className="text-sm text-gray-1100 text-right sm:flex sm:justify-between">
                    <span className="font-medium">{commonT('listPrice')}:</span>
                    <span className="font-normal line-through ml-1">{getFormattedPrice(number(price.listPrice))}</span>
                  </span>

                  <span className="text-sm mt-[6px] text-gray-1100 text-right  sm:flex sm:justify-between">
                    <span className="font-medium">{commonT('yourPrice')}:</span>
                    <span className="font-normal ml-1">{getFormattedPrice(number(price.bestPrice))}</span>
                  </span>
                </>
              )}
              {!price && <div className="c-loader self-end"></div>}
            </>
          )}
          {!showPrice && (
            <Button
              className="p-0 text-left flex items-center h-auto leading-none cursor-pointer"
              type="link"
              onClick={() => {
                trackEvent({
                  key: 'eventsData',
                  action: 'requestQuote',
                  payload: {
                    event_name: 'requestQuote',
                    request_quote_sku: product.catalogNumber,
                  },
                });
                router.push(getContactUsLink(lang));
              }}
            >
              {t('contact.us')}
            </Button>
          )}
        </div>
      )}
      {!price && <Skeleton rows={2} gap={[6]} width={['60%', '60%']} />}
    </>
  );
});
export { ListPrice };
